import React, { useEffect, useState } from 'react'
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../../../utils/constants';
import { FieldErrors } from '../../../../../domain/helpers/Errors';
import { formatDate } from '../../../../../common/GlobalFunctions';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { ReactComponent as PDFLogo } from '../../../../../images/pdf-icon.svg'
import { DocumentTemplateInterface } from '../../../../../models/ProcurementModule/DocumentTemplate';
import LoadingIcon from '../../../../../common/LoadingIcon';
import ToastMessage from '../../../../../common/ToastMessage';
import CustomDataGrid from '../../../../../common/CustomDataGrid';
import useDocumentTemplate from '../../../../../store/ReactQueries/general/documentTemplate/useDocumentTemplate';
import useAddDocumentTemplate from '../../../../../store/ReactQueries/general/documentTemplate/useAddDocumentTemplate';
import useUpdateDocumentTemplate from '../../../../../store/ReactQueries/general/documentTemplate/useUpdateDucumentTemplate';
import useDeleteDocumentTemplate from '../../../../../store/ReactQueries/general/documentTemplate/useDeleteDocumentTemplate';
import documentTemplateService from '../../../../../services/general/documentTemplateService';

export const DocumentTemplates = () => {
    const { language } = useLanguageStore();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [loadingPDF, setLoadingPDF] = useState<{ [key: string]: boolean }>({});
    const [form, setForm] = useState<DocumentTemplateInterface>({
        id: '',
        title: '',
        content: '',
        documentType: undefined,
    });

    const [modal, setModal] = useState<{ add: boolean, edit: boolean, view: boolean }>({
        add: false,
        edit: false,
        view: false
    });

    let { data: docTemplates, error, } = useDocumentTemplate(page, pageSize);

    const addDocTemplate = useAddDocumentTemplate(page, pageSize);
    const updatedDocTemplate = useUpdateDocumentTemplate(page, pageSize);
    const deleteDocTemplate = useDeleteDocumentTemplate(page, pageSize);

    useEffect(() => {
        if (error) ToastMessage.Failed(`Error: ${error.message}`);
    }, [error]);

    const handleDownloadPDF = async (id: string) => {
        if (id) {
            try {
                setLoadingPDF(prev => ({ ...prev, [id]: true }));
                const response = await documentTemplateService.GenerateTemplate(id);
                console.log('response', response)

                if (response) {
                    const link = document.createElement("a");
                    link.href = response;
                    link.download = "document.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    console.error("No valid download URL received.");
                }
            } catch (error) {
                console.error("Error downloading PDF:", error);
            }
            finally {
                setLoadingPDF(prev => ({ ...prev, [id]: false }));
            }
        }
    };

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false },
        { field: 'title', headerName: 'Title', type: "string", editable: true, width: 450 },
        {
            field: 'content',
            headerName: 'File',
            type: "string",
            editable: true,
            width: 100,
            renderCell: ({ row }) => (
                <div
                    className='pdf-icon-download'
                    role='button'
                    title={'Download template'}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDownloadPDF(row.id)
                    }}
                >
                    {
                        loadingPDF[row.id]
                            ? <span className='pt-2'><LoadingIcon width={25} color='#696CFF' /></span>
                            : <PDFLogo width="30" height="30" />
                    }

                </div>
            ),
        },
        { field: 'createdDate', headerName: 'CreatedDate', type: "dateTime", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'updatedDate', headerName: 'UpdatedDate', type: "dateTime", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'authorId', headerName: 'AuthorId', type: "string", editable: false, width: 150 },
        { field: 'modifiedById', headerName: 'ModifiedById', type: "string", editable: false, width: 150 },
    ];

    const addItems = () => {
        setForm({ ...form, title: '', id: '', content: '' });
        setModal({ ...modal, add: true });
        setErrors({});
    }

    const handleError = (error: unknown) => {
        if (error instanceof Error) {
            console.log(error.message);
            ToastMessage.Failed(error.message);
        } else {
            console.log("An unknown error occurred");
            ToastMessage.Failed();
        }
    };

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            deleteDocTemplate.mutate(id, {
                onError: (error) => handleError(error)
            });
        }
    };

    return (
        <CustomDataGrid
            name={language['DocumentTemplates']}
            newAddComponent="DocumentTemplates"
            rows={docTemplates || []}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            pageSize={pageSize}
            setForm={setForm}
            setPage={setPage}
            setModal={setModal}
            addItems={addItems}
            setErrors={setErrors}
            handleSave={function (): Promise<void> {
                throw new Error("Function not implemented.");
            }}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
            showColumnModal={[]}
            hideColumns={['id', 'authorId', 'modifiedById']}
        />
    );
}
export default DocumentTemplates;